import { QuoteRequestRecipient } from '../../../data/models';

export interface RfqResponseModalResult {
    cancelled: boolean;
    updatedRecipient?: QuoteRequestRecipient;
}

export interface NavListItem {
    label: string;
    value: RFQResponseComponents;
    iconClass: string;
    isSelected: boolean;
    isValid: boolean;
    isRequired: boolean;
    isEdited: boolean;
    secondaryLabel: string;
}

export enum RFQResponseComponents {
    Details = 'DETAILS',
    CostingItems = 'COSTINGITEMS',
    Attachments = 'ATTACHMENTS',
    Messages = 'MESSAGES',
}
